import { getAsyncStatusFromRtkQueryStates } from 'lib-shared-auth';
import { useEffect } from 'react';

import { flowsApi } from 'apis/flows';
import { uploadsApi } from 'apis/uploads';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { FileUsagePage } from '../../components/fileUsagePage/fileUsagePage';

export const SettingsAudioAnnouncement = (): JSX.Element => {
  const { id } = useAppPathParams('/settings/audio/announcement/:id');
  const [getAnnouncementUsage, { data, ...rtkQueryState }] =
    flowsApi.useLazyReadFlowsAnnouncementUsageQuery();
  const asyncStatus = getAsyncStatusFromRtkQueryStates(rtkQueryState);

  useEffect(() => {
    getAnnouncementUsage({ id });
  }, [getAnnouncementUsage, id]);

  const { data: announcementData } = uploadsApi.useReadAnnouncementsQuery();
  const announcementList = announcementData?.data.uploads;
  const announcement = announcementList?.find(
    ({ url }) => url.indexOf(id) >= 0,
  );

  return (
    <FileUsagePage
      type="announcement"
      usage={data?.data?.flows || []}
      file={announcement}
      asyncStatus={asyncStatus}
    />
  );
};
